import { useState, useCallback } from 'react';
import { qnaApi } from '../../../services/qnaApi';
import { mapHistoryData } from '../../../utils/chatFormattingUtils';

/**
 * 사용자/회사/관리자 전체 채팅 내역 목록을 관리하고 불러오는 훅.
 */
export const useChatHistory = (currentUser = {}) => {
    const [historyList, setHistoryList] = useState([]);
    const [isHistoryLoading, setIsHistoryLoading] = useState(false);

    const fetchHistoryList = useCallback(async (memberId, viewMode = 'personal') => {
        setIsHistoryLoading(true);
        try {
            const data = await qnaApi.historyList(memberId, viewMode);
            const formattedData = mapHistoryData(data, currentUser);
            setHistoryList(formattedData);
        } catch (error) {
            console.error('History List Error:', error);
        } finally {
            setIsHistoryLoading(false);
        }
    }, [currentUser]);

    return { historyList, isHistoryLoading, fetchHistoryList };
};
